const map = {
	"./4.jpg": 1745,
	"./5.jpg": 7412,
	"./8.jpg": 6885,
	"./IMG-20260703-WA0004.jpg": 5840,
	"./IMG-20260703-WA0006.jpg": 2450,
	"./IMG-20260703-WA0007.jpg": 8831,
	"./IMG-20260703-WA0009.jpg": 3257,
	"./IMG-20260703-WA0010.jpg": 7891,
	"./IMG-20260703-WA0011.jpg": 4758,
	"./IMG-20260703-WA0013.jpg": 8180,
	"./IMG-20260703-WA0014.jpg": 9615,
	"./IMG_6869.JPG": 4535,
	"./IMG_7258.JPG": 2846,
	"./IMG_8551.jpg": 4942,
	"./IMG_9133.JPG": 3250
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9375;